
import React from 'react'
// import styled from 'styled-components'

// import { FixedSpaceColumn } from 'lib-components/layout/flex-helpers'
import type { CitizenCustomizations } from 'lib-customizations/types'

import { citizenConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import UnorderedList from 'lib-components/atoms/UnorderedList'
import featureFlags from './featureFlags'
import mapConfig from './mapConfig'
import { H1, H2, P } from 'lib-components/typography'
import ExternalLink from 'lib-components/atoms/ExternalLink'
import colors from 'lib-customizations/common'

// const MultiLineCheckboxLabel = styled(FixedSpaceColumn).attrs({
//   spacing: 'zero'
// })`
//   margin-top: -6px;
// `

const customizations: CitizenCustomizations = {
  appConfig: citizenConfig,
  langs: ['fi', 'sv', 'en'],
  translations: {
    fi: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© Sastamalan kaupunki',
        privacyPolicyLink: (
          <a
            href="https://sastamala.fi/sastamala-info/tietosuoja/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Tietosuojaselosteet
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://sastamala.fi/sastamala-info/palaute/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Lähetä palautetta
          </a>
        ),
      },
      calendar: {
        absentPlanned: 'Vapaa poissaolo',
      },
      loginPage: {
        title: 'Sastamalan kaupungin varhaiskasvatus',
        login: {
          infoBoxText: (
            <>
              <P>
                Jos et pysty kirjautumaan, ota yhteyttä tukeen.
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "Tässä näkymässä voit hakea kartalta Sastamalan varhaiskasvatus- ja esiopetuspaikkoja",
        serviceVoucherLink:
          'https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/yksityinen-varhaiskasvatus/varhaiskasvatus-yksityisessa-paivakodissa/',
        privateUnitInfo: (
          <span>
            Tietoa yksityisistä päiväkodeista löydät{' '}
            <ExternalLink
              text="täältä."
              href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/yksityinen-varhaiskasvatus/"
              newTab
            />
          </span>
        ),
      },
      income: {
        title: 'Tulotiedot',
        description: (
          <>
            <P>
              Tällä sivulla voit lähettää selvitykset varhaiskasvatusmaksuun
              vaikuttavista omista ja lastesi tuloista. Voit myös tarkastella
              palauttamiasi tuloselvityksiä ja muokata tai poistaa niitä, kunnes
              viranomainen on käsitellyt tiedot. Lomakkeen käsittelyn jälkeen voit
              päivittää tulotietojasi toimittamalla uuden lomakkeen.
            </P>
            <P>
              Kunnallisen varhaiskasvatuksen asiakasmaksut määräytyvät
              prosenttiosuutena perheen bruttotuloista. Maksut vaihtelevat perheen
              koon ja tulojen sekä varhaiskasvatusajan mukaan. Tarkista
              asiakastiedotteen taulukosta (jonka löydät{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/"
              >
                täältä
              </a>
              ) tarvitseeko sinun toimittaa tuloselvitystä, vai kuuluuko perheenne
              automaattisesti korkeimman varhaiskasvatusmaksun piiriin.
            </P>
            <P>
              Lisätietoja maksuista:{' '}
              <a href="https://www.sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/">
                Maksut varhaiskasvatuksessa
              </a>
            </P>
            <strong>Tärkeää</strong>
            <ul>
              <li>
                Maksu määräytyy kaikkien samassa osoitteessa asuvien aikuisten
                tulojen perusteella. Sinun ja mahdollisen samassa osoitteessa asuvan
                puolisosi on ilmoitettava tulonne erikseen.
              </li>
            </ul>
          </>
        ),
        formDescription: (
          <>
            <P>
              Tuloselvitys liitteineen palautetaan kahden viikon kuluessa
              varhaiskasvatuksen aloittamisesta. Maksu voidaan määrätä
              puutteellisilla tulotiedoilla korkeimpaan maksuun. Puutteellisia
              tulotietoja ei korjata takautuvasti oikaisuvaatimusajan jälkeen.
            </P>
            <P>
              Asiakasmaksu peritään päätöksen mukaisesta varhaiskasvatuksen
              alkamispäivästä lähtien.
            </P>
            <P>
              Asiakkaan on viipymättä ilmoitettava tulojen ja perhekoon muutoksista
              varhaiskasvatuksen asiakasmaksuyksikköön. Viranomainen on tarvittaessa
              oikeutettu perimään varhaiskasvatusmaksuja myös takautuvasti.
            </P>
            <P>
              <strong>Huomioitavaa:</strong>
            </P>
            <UnorderedList>
              <li>
                Maksu voidaan tarkistaa kesken toimintavuotta, mikäli perheen
                tilanteessa, tuloissa tai lapsen palveluntarpeessa tapahtuu muutos.
                Maksua voidaan muuttaa myös lainsäädännön muutosten tai
                kaupunginhallituksen päätösten mukaisesti.
              </li>
              <li>
                Jos perheen tuloissa tapahtuu olennaisia (+/-10 %) muutoksia, on
                uusi tuloselvitys tehtävä välittömästi.
              </li>
            </UnorderedList>
            <P>
              Katso voimassaolevat tulorajat{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/"
              >
                tästä
              </a>
              .
            </P>
            <P>* Tähdellä merkityt tiedot ovat pakollisia</P>
          </>
        ),
      },
      applications: {
        editor: {
           unitPreference: {
            units: {
              serviceVoucherLink:
              'https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/yksityinen-varhaiskasvatus/varhaiskasvatus-yksityisessa-paivakodissa/',
            },
          },
          heading: {
            info: {
              PRESCHOOL: (
                <>
                  <P>
                    Lapsen on osallistuttava oppivelvollisuuden alkamista edeltävänä vuotena
                    vuoden kestävään esiopetukseen tai muuhun esiopetuksen tavoitteet saavuttavaan
                    toimintaan. Maksutonta esiopetusta annetaan noin 700 tuntia vuodessa,
                    20 tuntia viikossa. Kaikissa esiopetusyksiköissä tarjotaan lämmin ateria.
                  </P>
                  <P>
                    Koulujen yhteydessä esiopetuksessa oleville lapsille järjestetään koulupäivinä
                    esiopetukseen liittyvää varhaiskasvatusta aamuisin ja iltapäivisin pääsääntöisesti
                    klo 7-17 (erikseen sovittuna 6.30 alkaen). Liittyvä varhaiskasvatus on maksullista
                    ja siihen ilmoittaudutaan esiopetusilmoittautumisen yhteydessä.
                  </P>
                  <P>
                     Ilmoittaudu esiopetukseen tällä lomakkeella esiopetuskirjeen ohjeen mukaisesti.
                     Päätökset tulevat Suomi.fi-viestit -palveluun tai postitse,
                     mikäli et ole ottanut Suomi.fi -palvelua käyttöön.
                  </P>
                  <P>
                    Päätökset tulevat{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
            },
          },
          serviceNeed: {
            title: 'Palveluntarve',
            startDate: {
              clubTerm: 'Kerhon toimintakausi',
              clubTerms: 'Kerhon toimintakaudet',
              preschoolTerm: 'Esiopetuskausi',
              preschoolTerms: 'Esiopetuskaudet',
              label: {
                DAYCARE: 'Toivottu aloituspäivä',
                PRESCHOOL: 'Toivottu aloituspäivä',
                CLUB: 'Kerhon toivottu aloituspäivä'
              },
              noteOnDelay: 'Hakemuksen käsittelyaika on 4 kuukautta.',
              instructions: {
                DAYCARE: (
                  <>
                    Toivottua aloituspäivää on mahdollista muuttaa myöhemmäksi niin
                    kauan kuin hakemusta ei ole otettu käsittelyyn. Tämän jälkeen
                    toivotun aloituspäivän muutokset tehdään ottamalla yhteyttä
                    Sastamalan varhaiskasvatuksen palvelupäälliköihin.
                    Yhteystiedot löytyvät kaupungin nettisivuilta.
                  </>
                ),
                PRESCHOOL: (
                  <>
                    Toivottua aloituspäivää on mahdollista muuttaa myöhemmäksi niin
                    kauan kuin hakemusta ei ole otettu käsittelyyn. Tämän jälkeen
                    toivotun aloituspäivän muutokset tehdään ottamalla yhteyttä
                    Sastamalan varhaiskasvatuksen palvelupäälliköihin.
                    Yhteystiedot löytyvät kaupungin nettisivuilta.
                  </>
                ),
                CLUB: null
              } as {
                DAYCARE: React.JSX.Element | null
                PRESCHOOL: React.JSX.Element | null
                CLUB: React.JSX.Element | null
              },
              info: {
                PRESCHOOL: [
                  'Jos tarvitsette varhaiskasvatusta ennen esiopetuksen alkua, voitte hakea sitä tällä hakemuksella valitsemalla "Haen myös esiopetukseen liittyvää varhaiskasvatusta".'
                ],
              },
            },
            shiftCare: {
              label: 'Ilta- ja vuorohoito',
              instructions:
                'Vuorohoidolla tarkoitetaan viikonloppuna tai ympärivuorokautisesti tarvittavaa varhaiskasvatusta. Iltahoito on pääasiassa klo 6:00-18:00 ulkopuolella ja viikonloppuisin tapahtuvaa varhaiskasvatusta.',
              attachmentsMessage: {
                DAYCARE: (
                  <P>
                    Ilta- ja vuorohoito on tarkoitettu lapsille, joiden molemmat
                    vanhemmat ovat vuorotyössä tai opiskelevat pääsääntöisesti
                    iltaisin ja/tai viikonloppuisin. Hakemuksen liitteeksi
                    toimitetaan molempien vanhempien osalta työnantajan todistus
                    vuorotyöstä tai opiskelusta johtuvasta ilta- tai vuorohoidon
                    tarpeesta. Jos et voi lisätä liitteitä hakemukselle sähköisesti,
                    ota yhteyttä varhaiskasvatuksen palvelupäälliköihin.
                    Yhteystiedot löytyvät kaupungin nettisivuilta.
                  </P>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      Esiopetushakemukselle pyydämme liittämään samassa taloudessa
                      asuvien huoltajien osalta todistukset työnantajalta
                      säännöllisestä vuorotyöstä tai oppilaitoksen edustajalta
                      päätoimisesta iltaopiskelusta. Dokumenttien tulee olla
                      kirjattu sinä vuonna, kun hakemus esiopetukseen tehdään.
                    </P>
                    <P>
                      Ilta- ja vuorohoito on tarkoitettu lapsille, joiden molemmat
                      vanhemmat ovat vuorotyössä tai opiskelevat pääsääntöisesti
                      iltaisin ja/tai viikonloppuisin. Hakemuksen liitteeksi
                      toimitetaan molempien vanhempien osalta työnantajan todistus
                      vuorotyöstä tai opiskelusta johtuvasta ilta- tai vuorohoidon
                      tarpeesta. Jos et voi lisätä liitteitä hakemukselle
                      sähköisesti, ota yhteyttä varhaiskasvatuksen palvelupäälliköihin.
                      Yhteystiedot löytyvät kaupungin nettisivuilta.
                    </P>
                  </>
                )
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <P fitted={true}>
                    Mikäli varhaiskasvatuspaikan tarve johtuu äkillisestä
                    työllistymisestä tai opiskelusta, tulee paikkaa hakea
                    viimeistään <strong>kaksi viikkoa ennen</strong> kuin tarve
                    alkaa. Hakemuksen{' '}
                    <strong>liitteenä tulee olla työ- tai opiskelutodistus</strong>{' '}
                    molemmilta samassa taloudessa asuvilta huoltajilta.
                    Suosittelemme toimittamaan liitteen sähköisesti tässä, sillä
                    kahden viikon käsittelyaika alkaa siitä, kun olemme
                    vastaanottaneet hakemuksen tarvittavine liitteineen. Jos et voi
                    lisätä liitteitä hakemukselle sähköisesti, ota yhteyttä
                    varhaiskasvatuksen palvelupäälliköihin. Yhteystiedot löytyvät kaupungin nettisivuilta.
                  </P>
                ),
                subtitle:
                  'Lisää tähän työ- tai opiskelutodistus molemmilta vanhemmilta.'
              }
            },
            dailyTime: {
              connectedDaycareInfo: (
                <>
                  <P>
                    Voit hakea lapselle tarvittaessa{' '}
                    <strong>
                      esiopetukseen liittyvää varhaiskasvatusta, joka on
                      maksullista.
                    </strong>{' '}
                    Liittyvää varhaiskasvatusta järjestetään aamuisin ennen
                    esiopetusta ja esiopetuksen jälkeen esiopetusyksikön
                    aukioloaikojen mukaisesti.
                  </P>
                  <P>
                    Jos tarvitset varhaiskasvatusta ennen esiopetuksen alkua,
                    huomioi tämä aloituspäivämäärän valinnassa.
                  </P>
                  <P>
                    Palveluseteliyksikköihin haettaessa, liittyvän varhaiskasvatuksen
                    palveluseteliä haetaan valitsemalla hakutoiveeksi se
                    palveluseteliyksikkö, johon halutaan hakea.
                  </P>
                  <P>
                    Yksityisiin esiopetusyksiköihin haettaessa, liittyvä
                    varhaiskasvatus haetaan suoraan yksiköstä (pois lukien
                    palveluseteliyksiköt), yksiköt informoivat asiakkaita
                    hakutavasta. Jos esiopetushakemuksessa on haettu liityvää
                    varhaiskasvatusta yksityisestä yksiköstä, palveluohjaus muuttaa
                    hakemuksen vain esiopetushakemukseksi.
                  </P>
                  <P>
                    Saat varhaiskasvatuspaikasta erillisen kirjallisen päätöksen.
                    Päätös tulee{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi-viestit
                    -palvelua käyttöön.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <P>
                Lisätietoa varhaiskasvatuksen maksuista
                <br />
                <a
                  href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Maksut varhaiskasvatuksessa
                </a>
              </P>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Sastamalan varhaiskasvatuksessa virallisena osoitteena pidetään väestötiedoista saatavaa osoitetta. Osoite väestötiedoissa muuttuu hakijan tehdessä muuttoilmoituksen postiin tai maistraattiin.",
          },
        },
        creation: {
          applicationInfo: (
            <P>
              Hakemukseen voi tehdä muutoksia niin kauan kuin hakemusta ei ole
              otettu käsittelyyn. Tämän jälkeen muutokset hakemukseen tehdään
              ottamalla yhteyttä varhaiskasvatuksen palvelupäälliköihin. Yhteystiedot
              löytyvät kaupungin nettisivuilta. Voit perua jo tehdyn hakemuksen
              ilmoittamalla siitä.
            </P>
          ),
          transferApplicationInfo: {
            DAYCARE:
              "Lapsellasi on jo paikka Sastamalan kaupungin varhaiskasvatuksessa. Käytä tätä hakemusta hakeaksesi siirtoa toiseen varhaiskasvatusyksikköön.",
          },
        },
      },
      accessibilityStatement: (
        <>
          <H1>Saavutettavuusseloste</H1>
          <P>
            Tämä saavutettavuusseloste koskee Sastamalan kaupungin varhaiskasvatuksen
            eVaka-verkkopalvelua osoitteessa{' '}
            <a href="https://varhaiskasvatus.sastamala.fi">varhaiskasvatus.sastamala.fi</a>.
            Sastamalan kaupunki pyrkii takaamaan verkkopalvelun saavutettavuuden,
            parantamaan käyttäjäkokemusta jatkuvasti ja soveltamaan asianmukaisia
            saavutettavuusstandardeja.
          </P>
          <P>
            Palvelun saavutettavuuden on arvioinut palvelun kehitystiimi, ja seloste
            on laadittu 12.4.2022.
          </P>
          <H2>Palvelun vaatimustenmukaisuus</H2>
          <P>
            Verkkopalvelu täyttää lain asettamat kriittiset
            saavutettavuusvaatimukset WCAG v2.1 -tason AA mukaisesti. Palvelu ei ole
            vielä kaikilta osin vaatimusten mukainen.
          </P>
          <H2>Toimet saavutettavuuden tukemiseksi</H2>
          <P>
            Verkkopalvelun saavutettavuus varmistetaan muun muassa seuraavilla
            toimenpiteillä:
          </P>
          <ul>
            <li>
              Saavutettavuus huomioidaan alusta lähtien suunnitteluvaiheessa, mm.
              valitsemalla palvelun värit ja kirjaisinten koot saavutettavasti.
            </li>
            <li>
              Palvelun elementit on määritelty semantiikaltaan johdonmukaisesti.
            </li>
            <li>Palvelua testataan jatkuvasti ruudunlukijalla.</li>
            <li>
              Erilaiset käyttäjät testaavat palvelua ja antavat saavutettavuudesta
              palautetta.
            </li>
            <li>
              Sivuston saavutettavuudesta huolehditaan jatkuvalla valvonnalla
              tekniikan tai sisällön muuttuessa.
            </li>
          </ul>
          <P>
            Tätä selostetta päivitetään sivuston muutosten ja saavutettavuuden
            tarkistusten yhteydessä.
          </P>
          <H2>Tunnetut saavutettavuusongelmat</H2>
          <P>
            Käyttäjät saattavat edelleen kohdata sivustolla joitakin ongelmia.
            Seuraavassa on kuvaus tunnetuista saavutettavuusongelmista. Jos huomaat
            sivustolla ongelman, joka ei ole luettelossa, otathan meihin yhteyttä.
          </P>
          <ul>
            <li>
              Palvelun päivämäärävalitsinta ja monivalintojen alasvetovalikkoa ei
              ole optimoitu käytettäväksi ruudunlukijalla.
            </li>
            <li>
              Palvelun yksikkökartassa ei pysty liikkumaan
              näppäimistöllä/ruudunlukijalla, mutta yksikköjä voi selata samassa
              näkymässä olevalta listalta. Palvelussa käytetty kartta on kolmannen
              osapuolen tuottama.
            </li>
          </ul>
          <H2>Kolmannet osapuolet</H2>
          <P>
            Verkkopalvelussa käytetään seuraavia kolmannen osapuolen palveluita,
            joiden saavutettavuudesta emme voi vastata.
          </P>
          <ul>
            <li>Keycloak käyttäjän tunnistautumispalvelu</li>
            <li>Suomi.fi-tunnistautuminen</li>
            <li>Leaflet-karttapalvelu</li>
          </ul>
          <H2>Anna palautetta</H2>
          <P>
            Jos huomaat saavutettavuuspuutteen verkkopalvelussamme, kerro siitä
            meille. Voit antaa palautetta{' '}
            <ExternalLink
              href="https://sastamala.fi/sastamala-info/saavutettavuus/#gform_wrapper_8"
              text="verkkolomakkeella"
            />{' '}
            tai sähköpostitse{' '}
            <a href="mailto:sastamala@sastamala.fi">sastamala@sastamala.fi</a>.
          </P>
          <H2>Valvontaviranomainen</H2>
          <P>
            Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta
            meille sivuston ylläpitäjille. Vastauksessa voi mennä 14 päivää. Jos et
            ole tyytyväinen saamaasi vastaukseen, tai et saa vastausta lainkaan
            kahden viikon aikana, voit antaa palautteen Etelä-Suomen
            aluehallintovirastoon. Etelä-Suomen aluehallintoviraston sivulla
            kerrotaan tarkasti, miten valituksen voi tehdä, ja miten asia
            käsitellään.
          </P>
          <P>
            <strong>Valvontaviranomaisen yhteystiedot </strong>
            <br />
            Etelä-Suomen aluehallintovirasto <br />
            Saavutettavuuden valvonnan yksikkö
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            puhelinnumero vaihde 0295 016 000
            <br />
            Avoinna: ma-pe klo 8.00–16.15
          </P>
        </>
      ),
    },
    sv: {},
    en: {
      header: {
        lang: {
          fi: 'In Finnish',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'In Finnish',
          sv: '',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© City of Sastamala',
        privacyPolicyLink: (
          <a
            href="https://sastamala.fi/sastamala-info/tietosuoja/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Privacy notices
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://sastamala.fi/sastamala-info/palaute/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Give feedback
          </a>
        ),
      },
      calendar: {
        absentPlanned: 'Planned absence',
      },
      loginPage: {
        title: 'City of Sastamala early childhood education',
        login: {
          infoBoxText: (
            <>
              <P>
                If you are unable to login, please contact us.
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "In this view, you can search the map for Sastamala's early childhood education, pre-primary education and club places.",
        serviceVoucherLink:
          'https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/yksityinen-varhaiskasvatus/varhaiskasvatus-yksityisessa-paivakodissa/',
        privateUnitInfo: (
          <span>
            Information about private daycare can be found{' '}
            <ExternalLink
              text="here."
              href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/yksityinen-varhaiskasvatus/"
              newTab
            />
          </span>
        ),
      },
      income: {
        title: 'Income information',
        description: (
          <>
            <p>
              On this page, you can submit statements on your and your
              children&apos;s earnings that affect the early childhood education
              fee. You can also view, edit, or delete income statements that you
              have submitted until the authority has processed the information.
              After the form has been processed, you can update your income
              information by submitting a new form.
            </p>
            <p>
              The client fees for municipal early childhood education are determined
              as a percentage of the family’s gross income. The fees vary according
              to family size, income and time in early childhood education. Check
              the table in the customer bulletin (found{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/"
              >
                here
              </a>
              ) to see if you need to submit an income statement or if your family
              belongs to the category of the highest early childhood education fee.
            </p>
            <p>
              More information on the fees:{' '}
              <a href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/">
                Early childhood education fees
              </a>
            </p>
            <strong>Important</strong>
            <ul>
              <li>
                The fee is determined based on the income of all adults living at
                the same address. You and your possible spouse living at the same
                address must both declare your income separately.
              </li>
            </ul>
          </>
        ),
      },
      applications: {
        editor: {
          unitPreference: {
            units: {
              serviceVoucherLink:
              'https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/yksityinen-varhaiskasvatus/varhaiskasvatus-yksityisessa-paivakodissa/',
            },
          },
           heading: {
            info: {
              PRESCHOOL: (
                <>
                  <P>
                    The child must participate in one year of pre-primary education or other activity
                    achieving the objectives of pre-primary education in the year preceding the beginning
                    of compulsory education. Free pre-primary education is provided for approximately
                    700 hours a year, 20 hours a week. A warm meal is served in all pre-primary education
                    units. The decision is sent by Suomi.fi Messages service or by post.
                  </P>
                  <P>
                     Enroll in pre-primary education using this form in accordance with the instructions
                     in the pre-primary education letter. Decisions will be sent to the Suomi.fi
                     Messages service or by post if you have not enabled the Suomi.fi service.
                  </P>
                  <P fitted={true}>* Information marked with a star is required</P>
                </>
              ),
            },
          },
          serviceNeed: {
            startDate: {
              info: {
                PRESCHOOL: [
                'If you need early childhood education before the start of pre-primary education, you can apply for it with this application by selecting "I am also applying for early childhood education related to pre-primary education."'
                ],
              },
              instructions: {
                DAYCARE: (
                  <>
                    You can postpone your desired start date until the processing of
                    your application starts. After this, you can make changes to
                    your desired start date by contacting Early childhood education
                    service counselling. Contact information can be found on the city’s website.
                  </>
                ),
                PRESCHOOL: (
                  <>
                    You can postpone your desired start date until the processing of
                    your application starts. After this, you can make changes to
                    your desired start date by contacting Early childhood education
                    service counselling. Contact information can be found on the city’s website.
                  </>
                ),
                CLUB: null
              },
              placeholder: 'Select the start date',
              validationText: 'Desired start date: '
            },
            shiftCare: {
              label: 'Evening and round-the-clock care',
              instructions:
                'Round-the-clock care refers to early childhood education needed on weekends or around the clock. Evening and round-the-clock care is mainly early childhood education taking place outside the weekday hours of 6:00 and 18:00.',
              attachmentsMessage: {
                DAYCARE: (
                  <P>
                    Evening and round-the-clock care is intended for children whose
                    both parents do shift work or mainly study in the evening and/or
                    during the weekends. In addition to the application, both
                    parents will need to provide a document issued by their employer
                    concerning shift work or a document concerning their studies as
                    proof of the child’s need for evening or round-the-clock care.
                    We recommend that you send the additional documents through this
                    online system. If you are unable to add attachments to your
                    online application, please send the documents to Early
                    childhood education service counselling. Contact information can be found on the city’s website.
                  </P>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      If a guardian living in the same household does regular shift
                      work or attends evening studies full-time, they must provide
                      proof of this (a document issued by their employer or the
                      educational institution) together with the application for
                      pre-primary education. The documents must be dated in the year
                      when the application for pre-primary education is submitted.
                    </P>
                    <P>
                      Evening and round-the-clock care is intended for children
                      whose both parents do shift work or mainly study in the
                      evening and/or during the weekends. In addition to the
                      application, both parents will need to provide a document
                      issued by their employer concerning shift work or a document
                      concerning their studies as proof of the child’s need for
                      evening or round-the-clock care. We recommend that you send
                      the additional documents through this online system. If you
                      are unable to add attachments to your online application,
                      please send the documents to Early childhood education
                      service counselling. Contact information can be found on the city’s website.
                    </P>
                  </>
                )
              },
              attachmentsSubtitle:
                'Add here, for both parents, either a document issued by their employer concerning shift work or a document concerning their evening/weekend studies.'
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <P fitted={true}>
                    If the need for a place in early childhood education arises from
                    sudden employment or a sudden start of studies, you will need to
                    apply for a place no later than{' '}
                    <strong>two weeks before</strong> your child needs it. In
                    addition to the application, you will need to{' '}
                    <strong>
                      provide documents as proof of the employment or student status
                    </strong>{' '}
                    of both guardians living in the same household. If you are
                    unable to add attachments to your online application, please
                    send the documents by post to Early childhood education service
                    counselling. he processing period of two weeks will not begin until we
                    have received the application and the required attachments.
                  </P>
                ),
                subtitle:
                  'Add here documents as proof of the employment or student status of both guardians.'
              }
            },
             dailyTime: {
              connectedDaycareInfo: (
               <>
                <P>
                  You can apply for your child early childhood education related
                  to pre-primary education, which is subject to a charge. Related
                  early childhood education is provided in the mornings before
                  pre-primary education and in the afternoons after pre-primary
                  education in accordance with the opening hours of the
                  pre-primary education unit.
                </P>
                <P>
                  If you need connecting daycare before start of pre-primary education,
                  please take this into account when selecting the preferred start
                  date.
                </P>
                <P>
                  When applying for a service voucher unit, apply for a service
                  voucher for related early childhood education by selecting as
                  your preferred unit the service voucher unit you want to apply
                  for.
                </P>
                <P>
                  When applying for private pre-primary education units, apply for
                  related early childhood education directly from the unit (with
                  the exception of service voucher units); the units inform
                  customers about the application procedure. If you have applied
                  for related early childhood education from a private unit on the
                  pre-primary education application, the service guidance will
                  change your application to a pre-primary education application
                  only.
                </P>
                <P>
                  A separate written decision will be issued on the early
                  childhood education place. The decision will be sent to the{' '}
                  <a
                    href="https://www.suomi.fi/messages"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Suomi.fi Messages
                  </a>{' '}
                  service or by post if you do not use the{' '}
                  <a
                    href="https://www.suomi.fi/messages"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Suomi.fi messages
                  </a>{' '}
                  service.
                </P>
              </>
              ),
            },
          },
          fee: {
            links: (
              <P>
                More information about payments:
                <br />
                <a
                  href="https://sastamala.fi/kasvatus-ja-oppiminen/varhaiskasvatus/asiakasmaksut/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Payments in early childhood education
                </a>
              </P>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Sastamala's early childhood education considers the address retrieved from the Population Register Centre as the official address. The address in the Population Register Centre changes when the applicant makes a notification of move to Posti or the Local Register Office.",
          },
        },
        creation: {
          applicationInfo: (
            <P>
              You can make changes to your application until its processing starts.
              After this, you can make changes to your application by contacting
              Early childhood education service counselling. If
              you wish to cancel an application you have submitted, please contact
              the Early childhood education service counselling. Contact information can be found on the city’s website.
            </P>
          ),
          transferApplicationInfo: {
            DAYCARE:
              "Your child already has a place in the City of Sastamala's early childhood education. Use this application to apply for a transfer to another early childhood education unit.",
          },
        },
      },
      accessibilityStatement: (
        <>
          <H1>Accessibility statement</H1>
          <P>
            This accessibility statement applies to the City of Sastamala's early
            childhood education online service eVaka at{' '}
            <a href="https://varhaiskasvatus.sastamala.fi">varhaiskasvatus.sastamala.fi</a>.
            The City of Sastamala endeavours to ensure the accessibility of the online
            service, continuously improve the user experience and apply appropriate
            accessibility standards.
          </P>
          <P>
            The accessibility of the service was assessed by the development team of
            the service, and this statement was drawn up on 12 April 2022.
          </P>
          <H2>Compliance of the service</H2>
          <P>
            The online service complies with the statutory critical accessibility
            requirements in accordance with Level AA of the Accessibility Guidelines
            for the WCAG v2.1. The service is not yet fully compliant with the
            requirements.
          </P>
          <H2>Measures to support accessibility</H2>
          <P>
            The accessibility of the online service is ensured, among other things,
            by the following measures:
          </P>
          <ul>
            <li>
              Accessibility has been taken into account from the beginning of the
              design phase, for example, when choosing the colours and font sizes of
              the service.
            </li>
            <li>
              The service elements have been defined in consistently in terms of
              semantics.
            </li>
            <li>The service is continuously tested with a screen reader.</li>
            <li>
              Various users test the service and give feedback on its accessibility.
            </li>
            <li>
              When website technology or content changes, its accessibility is
              ensured through constant monitoring.
            </li>
          </ul>
          <P>
            This statement will be updated in conjunction with website changes and
            accessibility evaluations.
          </P>
          <H2>Known accessibility issues</H2>
          <P>
            Users may still encounter some issues on the website. The following
            contains a description of known accessibility issues. If you notice an
            issue on the site that is not listed, please contact us.
          </P>
          <ul>
            <li>
              Date pickers and multi-select dropdowns in the service are not
              optimised to be used with a screen reader.
            </li>
            <li>
              The service's unit map cannot be navigated using the keyboard/screen
              reader, but the units can be browsed on the list available in the same
              view. The map used in the service is produced by a third party.
            </li>
          </ul>
          <H2>Third parties</H2>
          <P>
            The online service uses the following third party services, the
            accessibility of which we cannot be responsible for.
          </P>
          <ul>
            <li>Keycloak user identification service</li>
            <li>Suomi.fi identification</li>
            <li>Leaflet map service</li>
          </ul>
          <H2>Give feedback</H2>
          <P>
            If you notice an accessibility gap in our online service, please let us
            know! You can give us feedback using the{' '}
            <ExternalLink
              href="https://sastamala.fi/sastamala-info/saavutettavuus/#gform_wrapper_8"
              text="online form"
            />{' '}
            or by emailing{' '}
            <a href="mailto:sastamala@sastamala.fi">sastamala@sastamala.fi</a>.
          </P>
          <H2>Supervisory authority</H2>
          <P>
            If you notice any accessibility issues on the website, please send us,
            the site administrator, feedback first. It may take us up to 14 days to
            reply. If you are not satisfied with the reply or you do not receive a
            reply within two weeks, you can give feedback to the Regional State
            Administrative Agency for Southern Finland. The website of the Regional
            State Administrative Agency for Southern Finland explains in detail how
            a complaint can be submitted, and how the matter will be processed.
          </P>
          <P>
            <strong>Contact information of the supervisory authority</strong>
            <br />
            Regional State Administrative Agency of Southern Finland
            <br />
            Accessibility Supervision Unit
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            tel. (exchange) 0295 016 000
            <br />
            Open: Mon-Fri 8.00–16.15
          </P>
        </>
      ),
    },
  },
  cityLogo: {
    src: MunicipalityLogo,
    alt: 'Sastamala logo',
  },
  routeLinkRootUrl: 'https://reittiopas.hsl.fi/reitti/',
  mapConfig,
  featureFlags,
  getMaxPreferredUnits() {
    return 3
  },
}

export default customizations
